import type { ReactNode } from 'react'
import { useViewerPermissions } from '@/auth/useViewerPermissions'
import { ForbiddenPage } from '@/pages/errors/Forbidden'

/** Renders `children` only when the viewer holds `permission`; otherwise the Forbidden page. */
export function RequirePermission({ permission, children }: { permission: string; children: ReactNode }) {
	const { permissions, isLoading } = useViewerPermissions()
	if (isLoading) return null
	return permissions.includes(permission) ? children : <ForbiddenPage />
}
